import React from 'react'
import classes from "./style.module.scss";
import ModalDropdown from '../../component/ModalDropdown';
import CloseIcon from '@mui/icons-material/Close';
import Button from '../../component/Button';
import { FormProvider, useForm } from 'react-hook-form';
import InputBox from '../../component/InputBox';
import Exported from '../../service/endpoints';
import request from '../../service';
import { Toast } from '../../service/toast';
import { saveLoadingState } from '../../redux/reducers/loadingSlice';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const ReasonModal = (props) => {
    const { isOpen = false, closePopUp, userId } = props

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const formMethods = useForm({
        mode: 'onSubmit',
    });
    const {
        handleSubmit,
        formState: { errors },
        register,
        trigger,
    } = formMethods;

    const redirectBack = () => {
        navigate('/admin/users')
    }

    const onSubmit = async (data) => {
        trigger();
        let url = `${Exported.Endpoints.updateRetailStatus}`
        let paramsObj = {
            userId: userId,
            isVerified: false,
            reason: data?.reason
        }
        dispatch(saveLoadingState(true))
        let successResponse = false
        await request({
            url: url,
            method: Exported.APIMethods.POST,
            data: {
                ...paramsObj
            }
        }).then((res) => {
            if (res?.data?.status) {
                successResponse = true              
            } else {
                successResponse = false
            }
        }).catch((err) => {
            console.log(err, "err")
            successResponse = false
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
        if (successResponse) {
            Toast({
                type: 'success',
                message: 'Retailer’s request has been rejected successfully.'
            })
            closePopUp()
        }
        dispatch(saveLoadingState(false))
        redirectBack()
    };

    return (
        <>
            <ModalDropdown isOpen={isOpen} closePopUp={closePopUp}>
                <div className={`${classes.reasonModalWrapper}`}>
                    <div className={`${classes.modalHeader} flex items-center justify-between`}>
                        <div className={`${classes.modalTitle}`}>Reason for Decline</div>
                        <div className={`${classes.modalCloser}`}>
                            <CloseIcon onClick={() => closePopUp()} />
                        </div>
                    </div>
                    <div className={`${classes.reasonFormContainer}`}>
                        <FormProvider {...formMethods}>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className={`${classes.formGroup}`}>

                                </div>
                                <div className={`${classes.formField}`}>
                                    <InputBox
                                        label={"Reason"}
                                        className={`w-[100%] ${classes.notesInput}`}
                                        name={"reason"}
                                        type={"textarea"}
                                        {...register("reason", {
                                            required: true,
                                        })}
                                        error={errors.reason}
                                        messages={{
                                            required: "Reason is required",
                                        }}
                                    />
                                </div>
                                <div className='flex justify-end'>
                                    <Button text={"Submit"} className={`w-[100%] my-4`} smallBtn />
                                </div>
                            </form>
                        </FormProvider>
                    </div>
                </div>
            </ModalDropdown>
        </>
    );
}

export default ReasonModal